import { render, staticRenderFns } from "./FavoriteFields.vue?vue&type=template&id=13f39af4&scoped=true&lang=pug"
import script from "./FavoriteFields.vue?vue&type=script&lang=js"
export * from "./FavoriteFields.vue?vue&type=script&lang=js"
import style0 from "./FavoriteFields.vue?vue&type=style&index=0&id=13f39af4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "13f39af4",
  null
  
)

export default component.exports